/* ZeroBarro — scripts propios (vanilla, sin librerías)
   Varias secciones incluyen esta misma etiqueta <script>; el guard evita
   que se inicialice más de una vez si el archivo se carga repetido. */

document.addEventListener('DOMContentLoaded', function () {
  if (window.__mtScriptsInit) return;
  window.__mtScriptsInit = true;
  initReveal();
  initComparador();
  initContador();
  initGaleriaProducto();
  initSelectorVariantes();
  initFaq();
  initGuiaTallas();
  initCarruselProducto();
});

/* Revela elementos .mt-reveal / .mt-reveal-scale al entrar en pantalla */
function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-mt-delay') || 0;
        setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

/* Comparador antes/después con deslizador */
function initComparador() {
  document.querySelectorAll('.mt-comparador').forEach(function (wrap) {
    var handle = wrap.querySelector('.mt-comparador-asa');
    var after = wrap.querySelector('.mt-comparador-despues');
    if (!handle || !after) return;
    var dragging = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }

    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(e.clientX);
    });
    handle.addEventListener('pointerup', function () { dragging = false; });
    wrap.addEventListener('click', function (e) {
      if (e.target === handle) return;
      setPos(e.clientX);
    });
    handle.addEventListener('keydown', function (e) {
      var rect = wrap.getBoundingClientRect();
      var current = parseFloat(handle.style.left) || 50;
      if (e.key === 'ArrowLeft') { setPos(rect.left + rect.width * (current - 5) / 100); }
      if (e.key === 'ArrowRight') { setPos(rect.left + rect.width * (current + 5) / 100); }
    });
  });
}

/* Cifras animadas (count-up) */
function initContador() {
  var els = document.querySelectorAll('.mt-contador');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-target') || '0');
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target * eased;
        el.textContent = (target % 1 === 0 ? Math.round(value) : value.toFixed(1)) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      obs.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

/* Galería de producto: miniatura -> imagen principal */
function initGaleriaProducto() {
  document.querySelectorAll('.mt-producto-galeria').forEach(function (galeria) {
    var main = galeria.querySelector('.mt-producto-imagen-principal img');
    var thumbs = galeria.querySelectorAll('.mt-producto-miniatura');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-full');
        if (!fullSrc) return;
        main.setAttribute('src', fullSrc);
        thumbs.forEach(function (t) { t.classList.remove('mt-activa'); });
        thumb.classList.add('mt-activa');
      });
    });
  });
}

/* Selector de variantes (talla/color) */
function initSelectorVariantes() {
  document.querySelectorAll('.mt-producto-form').forEach(function (form) {
    var dataEl = form.querySelector('.mt-variantes-json');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('.mt-producto-precio-actual');
    var compareEl = form.querySelector('.mt-producto-precio-tachado');
    var submitBtn = form.querySelector('.mt-producto-comprar');
    var selects = form.querySelectorAll('.mt-variante-select');

    function moneyFmt(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    }

    function findMatch() {
      var selected = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function update() {
      var match = findMatch();
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = moneyFmt(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = moneyFmt(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        if (match.available) {
          submitBtn.disabled = false;
          submitBtn.querySelector('.mt-btn-texto').textContent = submitBtn.getAttribute('data-texto-disponible');
        } else {
          submitBtn.disabled = true;
          submitBtn.querySelector('.mt-btn-texto').textContent = submitBtn.getAttribute('data-texto-agotado');
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });
}

/* Carrusel de fotos del producto (móvil): puntos + avance automático */
function initCarruselProducto() {
  document.querySelectorAll('[data-mt-carrusel]').forEach(function (carrusel) {
    var contenedorPuntos = carrusel.parentElement.querySelector('[data-mt-carrusel-puntos]');
    if (!contenedorPuntos) return;
    var puntos = contenedorPuntos.querySelectorAll('.mt-producto-punto');
    var totalFotos = puntos.length;
    if (!totalFotos) return;

    var actualizando = false;
    function indiceActual() {
      return Math.round(carrusel.scrollLeft / carrusel.clientWidth);
    }
    function marcarPunto(indice) {
      puntos.forEach(function (p, i) { p.classList.toggle('mt-activa', i === indice); });
    }
    carrusel.addEventListener('scroll', function () {
      if (actualizando) return;
      actualizando = true;
      requestAnimationFrame(function () {
        marcarPunto(indiceActual());
        actualizando = false;
      });
    });

    // Avance automático cada 3.5s; se pausa si el usuario interactúa y no
    // se ejecuta mientras el carrusel no esté visible en pantalla.
    var reproduciendo = true;
    var intervalo = null;

    function avanzar() {
      if (!reproduciendo) return;
      var siguiente = (indiceActual() + 1) % totalFotos;
      carrusel.scrollTo({ left: siguiente * carrusel.clientWidth, behavior: 'smooth' });
    }
    function iniciarAuto() {
      detenerAuto();
      intervalo = setInterval(avanzar, 3500);
    }
    function detenerAuto() {
      if (intervalo) { clearInterval(intervalo); intervalo = null; }
    }
    function pausarPorInteraccion() {
      reproduciendo = false;
      detenerAuto();
    }

    carrusel.addEventListener('pointerdown', pausarPorInteraccion, { passive: true });
    carrusel.addEventListener('touchstart', pausarPorInteraccion, { passive: true });

    if (totalFotos > 1 && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && reproduciendo) {
            iniciarAuto();
          } else {
            detenerAuto();
          }
        });
      }, { threshold: 0.6 });
      obs.observe(carrusel);
    } else if (totalFotos > 1) {
      iniciarAuto();
    }
  });
}

/* Guía de tallas: abre/cierra la ventana emergente con la tabla */
function initGuiaTallas() {
  var fondo = document.querySelector('[data-mt-fondo-guia-tallas]');
  if (!fondo) return;

  document.querySelectorAll('[data-mt-abrir-guia-tallas]').forEach(function (boton) {
    boton.addEventListener('click', function () {
      fondo.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  });

  function cerrar() {
    fondo.hidden = true;
    document.body.style.overflow = '';
  }
  fondo.addEventListener('click', function (e) {
    if (e.target === fondo) cerrar();
  });
  var cerrarBtn = fondo.querySelector('[data-mt-cerrar-guia-tallas]');
  if (cerrarBtn) cerrarBtn.addEventListener('click', cerrar);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !fondo.hidden) cerrar();
  });
}

/* FAQ desplegable simple */
function initFaq() {
  document.querySelectorAll('.mt-faq-item').forEach(function (item) {
    var pregunta = item.querySelector('.mt-faq-pregunta');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-abierto');
      item.closest('.mt-faq-lista').querySelectorAll('.mt-faq-item').forEach(function (i) { i.classList.remove('mt-abierto'); });
      if (!abierto) item.classList.add('mt-abierto');
    });
  });
}
